import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=b219560e&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=b219560e&prod&scoped=scoped&lang=less"
import style1 from "./Details.vue?vue&type=style&index=1&id=b219560e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b219560e",
  null
  
)

export default component.exports